<template>
  <div class="row">
    <div class="col-md-8 offset-md-2 foreground-content">
      <h1 class="mb-5">
        {{ title }}
      </h1>
      <div class="description" v-html="descriptionHtml" />
      <div class="mt-4 mb-2">
        <a v-if="showJoin" class="btn btn-lg btn-success" :href="joinLocalChapterUrl">
          {{ i18n.t('local_chapters.show.join') }}
        </a>
        <div v-if="showLogin" class="mt-2">
          <span>{{ i18n.t('local_chapters.show.already_member') }}</span>
          <a :href="signInUrl">
            {{ i18n.t('local_chapters.show.log_in') }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const SIGN_IN_URL = '/users/sign_in'

export default {
  props: {
    descriptionHtml: {
      type: String,
      required: true
    },
    joinLocalChapterUrl: {
      type: String,
      required: true
    },
    showJoin: {
      type: Boolean,
      required: true
    },
    showLogin: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      signInUrl: SIGN_IN_URL
    }
  }
}
</script>
